const DataReferences = {
    name1: "Cesar Esquivel",
    ocupation1: "(Instructor SENA)",
    phone1: "+57 321 3173993",

    name2: "Sergio Paez",
    ocupation2: "(Abogado)",
    phone2: "+57 313 4059787",
}

export default DataReferences;